module.exports = __webpack_public_path__ + "static/media/french_horn.12dffc48.wav";